import { useCallback } from "react";
import { useMutation } from "@apollo/client/react";

import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";
import { StackContext } from "views/Stack/Context";

import { REMOVE_STACK_SCHEDULING_SCHEDULED_DELETE } from "./gql";

const useRemoveScheduledDelete = () => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);
  const { stack } = useTypedContext(StackContext);

  const [stackScheduledDeleteDelete, { loading }] = useMutation(
    REMOVE_STACK_SCHEDULING_SCHEDULED_DELETE,
    {
      refetchQueries: ["GetStackScheduling"],
      awaitRefetchQueries: true,
    }
  );

  const removeScheduledDelete = useCallback(
    (scheduleId: string, successCallback?: () => void) => {
      stackScheduledDeleteDelete({
        variables: {
          scheduleId,
          stack: stack.id,
        },
      })
        .then(({ data }) => {
          if (data) {
            reportSuccess({
              message: `Delete Stack schedule successfully removed.`,
            });
            successCallback?.();
          }
        })
        .catch(onError);
    },
    [onError, reportSuccess, stack.id, stackScheduledDeleteDelete]
  );

  return {
    removeScheduledDelete,
    loading,
  };
};

export default useRemoveScheduledDelete;
